import styled from "styled-components";
import { Modal } from "components/Modal";

export const StrategyModalContainer = styled(Modal)`
  .modal-dialog {
    max-width: 582px;
  }

  .modal-content {
    padding: 0px;
    margin: 0px;
    border: 0px;

    .modal-body {
      padding: 0 0 2rem 0;
      margin-top: 0px;

      .container {
        display: flex;
        gap: 20px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 0 11px;

        .carousel-wrapper {
          .carousel-item {
            margin: 0 auto;
            width: 310px;
            float: none;

            .card {
              margin-top: 20px;
            }
          }

          .carousel-indicators {
            display: none;
          }

          .carousel-control-next,
          .carousel-control-prev {
            outline: 0;
            opacity: 0.9;
            width: 40px;
            height: 40px;
            border-radius: 50%;
            background-color: ${({ theme }) => theme.input.bg.secondary};
            display: flex;
            justify-content: center;
            align-items: center;

            svg {
              width: 18px;
              height: 18px;
              padding-left: 3px;
              padding-top: 2px;
            }
          }

          .carousel-control-next {
            right: -5rem;
            position: absolute;
            top: 50%;
          }

          .carousel-control-prev {
            left: -5rem;
            position: absolute;
            top: 50%;
          }

          .carousel-caption {
            position: relative;
            justify-content: center;
            display: flex;
            left: 0;
            right: 0;
          }
        }
      }

      .content-wrapper {
        padding: 20px 20px 0px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;

        .heading {
          font-weight: 600;
          font-size: 25px;
          line-height: 35px;
          justify-content: center;
          display: flex;
          margin-bottom: 0px;
        }

        .strategy-description {
          border: 1px solid #048af5;
          margin-top: 20px;
          width: 100%;
          border-radius: 10px;
          font-size: 14px;
          line-height: 20px;
          background-color: ${({ theme }) => theme.aside.bg.secondary};

          .card-body {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            padding: 0px 10px 10px;
            gap: 5px;

            .heading {
              color: ${({ theme }) => theme.card.font.tertiary};
              font-size: 18px;
              font-weight: 500;
            }

            span {
              color: ${({ theme }) => theme.card.font.secondary};
              font-size: 14px;
              font-weight: 400;
            }
          }
        }

        .button-wrapper {
          width: 80%;
          margin-top: 20px;
          display: flex;
          justify-content: space-between;
          padding: 0 20px;

          button {
            text-wrap: nowrap;
          }
        }
      }
    }
  }

  @media screen and (max-width: 524px) and (min-width: 420px) {
    .modal-dialog {
      max-width: auto;

      .modal-content .modal-body .container .carousel-wrapper {
        .carousel-control-next {
          right: -2.5rem;
        }
        .carousel-control-prev {
          left: -2.5rem;
        }
      }
    }
  }
  @media screen and (max-width: 421px) {
    .modal-content .modal-body {
      .button-wrapper {
        button {
          &:first-child {
            margin-bottom: 10px;
          }
        }
      }
      .container .carousel-wrapper {
        .carousel-control-next {
          right: -1rem;
        }
        .carousel-control-prev {
          left: -1rem;
        }
      }
    }
  }
`;
